import {
  AuthLayout,
  DefaultLayout
} from "@/components/layouts"

export const publicRoute = [{
    path: "*",
    component: () => import("@/views/error/NotFound.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: AuthLayout,
    meta: {
      title: "Login"
    },
  }
]

export const protectedRoute = [{
  path: "/",
  component: DefaultLayout,
  meta: {
    title: "Dashboard",
    group: "apps",
    icon: ""
  },
  redirect: "/dashboard",
  children: [{
      path: "/dashboard",
      name: "Dashboard",
      meta: {
        title: "Dashboard",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/Dashboard.vue")
    },
    {
      path: "/addcategory",
      name: "Add Category",
      meta: {
        title: "Add Category",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddCategory.vue")
    },
    {
      path: "/addcoursecategory",
      name: "Add Course Category",
      meta: {
        title: "Add Course Category",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddCourseCategory.vue")
    },
    {
      path: "/addcourse",
      name: "Add Course",
      meta: {
        title: "Add Course",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddCourseDetails.vue")
    },
    {
      path: "/addcoursedetails",
      name: "Add Course Details",
      meta: {
        title: "Add Course Details",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddCourseTopic.vue")
    },
    {
      path: "/addvideos",
      name: "Add Course Videos",
      meta: {
        title: "Add Course Videos",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddVideos.vue")
    },
    {
      path: "/addcurriculam",
      name: "Add Course Curriculam",
      meta: {
        title: "Add Course Curriculam",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddCurriculam.vue")
    },
    {
      path: "/addfaqs",
      name: "Add Course FAQs",
      meta: {
        title: "Add Course FAQs",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddFAQs.vue")
    },
    {
      path: "/addfeature",
      name: "Add Course Features",
      meta: {
        title: "Add Course Features",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddFeature.vue")
    },
    {
      path: "/addbanners",
      name: "Add Banners",
      meta: {
        title: "Add Banners",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddBanners.vue")
    },
    {
      path: "/addjoblisting",
      name: "Add Job Listing",
      meta: {
        title: "Add Job Listing",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddJobListing.vue")
    },
    {
      path: "/appliedjobs",
      name: "Applied Jobs List",
      meta: {
        title: "Applied Jobs List",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/JobsApplied.vue")
    },
    {
      path: "/createoffers",
      name: "Create Offers",
      meta: {
        title: "Create Offers",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/CreateOffers.vue")
    },
    {
      path: "/addschedule",
      name: "Add Schedule",
      meta: {
        title: "Add Schedule",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddSchedule.vue")
    },
    {
      path: "/addminiproject",
      name: "Mini Project",
      meta: {
        title: "Mini Project",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddMiniProject.vue")
    },
    {
      path: "/addpricing",
      name: "Add Course Pricing",
      meta: {
        title: "Add Course Pricing",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddCoursePricing.vue")
    },
    {
      path: "/addcourseseo",
      name: "Add Course SEO",
      meta: {
        title: "Add Course SEO",
        group: "apps",
        icon: "dashboard"
      },
      component: () => import("@/views/AddCourseSEO.vue")
    },
    {
      path: "/forum",
      name: "Fourm",
      meta: {
        title: "Fourm",
        group: "apps",
        icon: "forum"
      },
      component: () => import("@/views/ViewForum.vue")
    },
    {
      path: "/reviewlist",
      name: "Review List",
      meta: {
        title: "Review List",
        group: "apps",
        icon: "rate_review"
      },
      component: () => import("@/views/ViewReviewList.vue")
    },
    {
      path: "/activities",
      name: "Activities",
      meta: {
        title: "Activities",
        group: "apps",
        icon: "local_activity"
      },
      component: () => import("@/views/Activities.vue")
    },
    {
      path: "/sales",
      name: "Sales",
      meta: {
        title: "Sales",
        group: "apps",
        icon: "money"
      },
      component: () => import("@/views/Sales.vue")
    },
    {
      path: "/onlinesales",
      name: "Self Paced Sales",
      meta: {
        title: "Self Paced Sales",
        group: "apps",
        icon: "money"
      },
      component: () => import("@/views/OnlineSales.vue")
    },
    {
      path: "/classroomsales",
      name: "Classroom Sales",
      meta: {
        title: "Classroom Sales",
        group: "apps",
        icon: "money"
      },
      component: () => import("@/views/ClassroomSales.vue")
    },
    {
      path: "/webinarsales",
      name: "Online Sales",
      meta: {
        title: "Online Sales",
        group: "apps",
        icon: "money"
      },
      component: () => import("@/views/WebinarSales.vue")
    },
    {
      path: "/projectsales",
      name: "Project Sales",
      meta: {
        title: "Project Sales",
        group: "apps",
        icon: "money"
      },
      component: () => import("@/views/ProjectSales.vue")
    },
    {
      path: "/userlist",
      name: "User List",
      meta: {
        title: "User List",
        group: "apps",
        icon: "people"
      },
      component: () => import("@/views/UserList.vue")
    },
    {
      path: "/trainerlist",
      name: "Trainer List",
      meta: {
        title: "Trainer List",
        group: "apps",
        icon: "people"
      },
      component: () => import("@/views/TrainerList.vue")
    },
    {
      path: "/trainercourse",
      name: "Trainer Courses",
      meta: {
        title: "Trainer Courses",
        group: "apps",
        icon: "people"
      },
      component: () => import("@/views/TrainerCourseList.vue")
    },
    {
      path: "/userregisteration",
      name: "User Registration",
      meta: {
        title: "User Registration",
        group: "apps",
        icon: "people"
      },
      component: () => import("@/views/UserRegistration.vue")
    },
    {
      path: "/support",
      name: "Support",
      meta: {
        title: "Support",
        group: "apps",
        icon: "contact_support"
      },
      component: () => import("@/views/Support.vue")
    },
    {
      path: "/enquiry",
      name: "Enquiry",
      meta: {
        title: "Enquiry",
        group: "apps",
        icon: "perm_contact_calendar"
      },
      component: () => import("@/views/Enquiry.vue")
    },
    {
      path: "/companylogo",
      name: "Company Logo",
      meta: {
        title: "Company Logo",
        group: "apps",
        icon: "work"
      },
      component: () => import("@/views/AddCompanyLogo.vue")
    },
    {
      path: "/testimonials",
      name: "Testimonials",
      meta: {
        title: "Testimonials",
        group: "apps",
        icon: "work"
      },
      component: () => import("@/views/Testimonials.vue")
    },
    {
      path: "/results",
      name: "Result Upload",
      meta: {
        title: "Result Upload",
        group: "apps",
        icon: "work"
      },
      component: () => import("@/views/ResultUpload.vue")
    },
    {
      path: "/pageseo",
      name: "Page SEO",
      meta: {
        title: "Page SEO",
        group: "apps",
        icon: "work"
      },
      component: () => import("@/views/PageSEO.vue")
    },
    {
      path: "/addusers",
      name: "Add Users",
      meta: {
        title: "Add Users",
        group: "apps",
        icon: "work"
      },
      component: () => import("@/views/AddUsers.vue")
    },
    {
      path: "/webinar",
      name: "Webinar",
      meta: {
        title: "Webinar",
        group: "apps",
        icon: "aspect_ratio"
      },
      component: () => import("@/views/Webinar.vue")
    },
    {
      path: "/webinarregistrations",
      name: "Webinar Registrations",
      meta: {
        title: "Webinar Registrations",
        group: "apps",
        icon: "chrome_reader_mode"
      },
      component: () => import("@/views/WebinarRegistrations.vue")
    },
    {
      path: "/403",
      name: "Forbidden",
      meta: {
        title: "Access Denied",
        hiddenInMenu: true
      },
      component: () => import("@/views/error/Deny.vue")
    }
  ]
}]